// utils/tagsColeccion.js — P3-4. Las COLECCIONES son etiquetas (tags) de Woo con
// slug `coleccion-*` (medido: D2 confirmado); el resto de las etiquetas (p. ej.
// `Sale`, `mac`) son normales y NO son colecciones. El nombre visible de una
// colección es «Colección: X»; se muestra como «X».
//
// LO CRÍTICO (P3-4): al guardar las colecciones de un producto hay que ESCRIBIR
// la lista de tags completa, y un reemplazo ingenuo borraría las etiquetas
// normales. `mergeTagsColeccion` toma las etiquetas ACTUALES del producto y las
// colecciones elegidas, y devuelve la lista final preservando TODO lo que no es
// colección. CJS a propósito (lo usan el payload del frontend y buildCatalogPayload
// del backend, como tiposProducto.js). Lo fija tagsColeccion.test.js.

const PREFIJO_SLUG = 'coleccion-';
const PREFIJO_NOMBRE = 'Colección: ';

function esTagColeccion(tag) {
  return !!(tag && typeof tag.slug === 'string' && tag.slug.toLowerCase().startsWith(PREFIJO_SLUG));
}

// «Colección: Essential Luxé» → «Essential Luxé»; si no trae el prefijo, el nombre tal cual.
function nombreVisibleColeccion(tag) {
  const n = String((tag && tag.name) || '');
  return n.startsWith(PREFIJO_NOMBRE) ? n.slice(PREFIJO_NOMBRE.length) : n;
}

// slug de una colección a partir del nombre visible: «Essential Luxé» → «coleccion-essential-luxe».
function slugDeColeccion(nombreVisible) {
  const base = String(nombreVisible || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return `${PREFIJO_SLUG}${base}`;
}
// el nombre Woo que se guarda para una colección: «Colección: X».
function nombreDeColeccion(nombreVisible) {
  return `${PREFIJO_NOMBRE}${String(nombreVisible || '').trim()}`;
}

// Separa las etiquetas de un producto en { colecciones, otros } (ambas listas de tags).
function separarTags(tagsDelProducto) {
  const colecciones = [];
  const otros = [];
  for (const t of tagsDelProducto || []) (esTagColeccion(t) ? colecciones : otros).push(t);
  return { colecciones, otros };
}

// LA FUNCIÓN CRÍTICA. Devuelve la lista de IDS de tags a escribir en Woo:
//   (todas las etiquetas NO-colección del producto, preservadas)
//   + (las colecciones elegidas por el usuario).
// `tagsDelProducto`: [{id, slug, name}] actuales. `coleccionIdsElegidas`: ids de
// las colecciones seleccionadas. Dedup, sin asumir que las elegidas son
// colecciones válidas (se confía en el id). El orden: otros primero, luego
// colecciones (estable para diffs).
function mergeTagsColeccion(tagsDelProducto, coleccionIdsElegidas) {
  const { otros } = separarTags(tagsDelProducto);
  const ids = [];
  const vistos = new Set();
  for (const t of otros) {
    if (t && t.id != null && !vistos.has(t.id)) { vistos.add(t.id); ids.push(t.id); }
  }
  for (const id of coleccionIdsElegidas || []) {
    const n = Number(id);
    if (Number.isFinite(n) && !vistos.has(n)) { vistos.add(n); ids.push(n); }
  }
  return ids;
}

module.exports = {
  PREFIJO_SLUG, PREFIJO_NOMBRE,
  esTagColeccion, nombreVisibleColeccion, slugDeColeccion, nombreDeColeccion,
  separarTags, mergeTagsColeccion,
};
